import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { LoginCredentials } from '../../auth/types/login.interface';
import { BaseService } from './base.service';

@Injectable()
export class CommonAuthService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    login(login: LoginCredentials): Observable<any> {
        const body = {
            username: login.username,
            password: login.password
        };
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        return this.http.post(this.getApiUrl() + '/auth/login', body, {headers});
    }

    loginUserWithToken(): Observable<any> {
        // TODO refactor
        return of(true);
    }
}
